module.exports = __webpack_public_path__ + "img/p5.95ab1feb.png";